export class PopoverDefaultTextStyle {
  size = '';
  font = 'tb-font-primary';
  color = '';
  position = 'uk-position-center';

  static normalize(styles: Partial<PopoverDefaultTextStyle>): PopoverDefaultTextStyle {
    const pureStyles = new PopoverDefaultTextStyle();

    pureStyles.size = styles.size ?? pureStyles.size;
    pureStyles.font = styles.font ?? pureStyles.font;
    pureStyles.color = styles.color ?? pureStyles.color;
    pureStyles.position = styles.position ?? pureStyles.position;

    return pureStyles;
  }
}
